import advanceDialog from '../templateSelect';
import MSelect from '@/components/lots/otpSelect2';
import groupDialog from '../../../../../components/personOne/groupDialog';
import { dictWithUrl } from '@/components/otpPanel/api';
import { contractSave, uploadTemplate, uploadListNew, delFile, uploadPost, getCompanySite, contractSelect, mipFlowType, checkDigitalValue, updateModuleFile, tplDownload } from '../../../../../../lsrm/api/bidScheme.js';
import { filePreview } from '@/utils/filePreview.js';
import { mapGetters } from 'vuex';
import ossBtn from '../../../../../components/ossMoreFile/ossMoreFile.vue';
import privilegeDialog from '../privilegeDialog.vue';
import contractInfo from './contractInfo.vue';
import copyDialog from './copyDialog.vue';
import dayjs from 'dayjs';

export default {
    components: { groupDialog, ossBtn, advanceDialog, privilegeDialog, contractInfo, MSelect, copyDialog },
    data() {
        return {
            showCopyDialog: false,
            dialogVisible: false,
            loadSave: false,
            saveButton: true, // 保存按钮是否可点击
            privilegeBtn: true,
            isPrivilege: false, // 是否点击了特权修改按钮
            changeSeq: '', // 点击特权修改按钮时间戳
            changeReson: '', // 特权修改理由
            showPrivilegeDialog: false,
            form: {
                bidNo: '',
                bidName: '',
                organizerCode: '',
                companyCode: '',
                siteCode: '',
                bidStatus: '',
                organizerName: '',
                companyName: '',
                siteName: '',
                centerCode: '',
                centerName: '',
                signUpEndTime: '',
                purchaseStartTime: '',
                depositEndTime: '',
                quoteStartTime: '',
                currency: '',
                bidPrice: '',
                deposit: '',
                businessScale: '',
                lowerLastRound: '',
                quotePrecision: 0,
                round: '',
                rankedVisible: '',
                ralationQuote: '',
                lowestQuoteVisible: '',
                blockPriceMaintain: '',
                syntheticalScore: '',
                skillProportion: '',
                businessProportion: '',
                extraProportion: '', // 附加分权重(%)
                priceProportion: '',
                blockPriceControl: '',
                changeBidMin: '',
                priceMax: '',
                specialPermitFlag: '',
                remarks: '',
                professionalCompany: '',
                accountEntity: '',
                accountEntityName: '',
                accountCompanyName: '',
                businessType: '',
                servicesType: '',
                contractEffectiveTime: '',
                contractSuspendTime: '',
                taxRate: '',
                cashRation: '',
                oilCardRation: '',
                acceptanceRation: '',
                contractDepositRation: '',
                invoiceType: '',
                paymentTerms: '',
                customerType: '',
                transType: '',
                liquidatedDamagesRation: '',
                needCollect: '',
                collectTypeCode: [],
                customerCode: '',
                customerName: '',
                customers: [],
                unionBidCompanyList: [],
                bigIndustry: '',
            },
            formFoot: {
                tableData: [],
                footRules: {
                    extStr1: [{ required: true, message: ' ', trigger: 'change' }]
                }
            },
            isShowDialog: false,
            siteFormData: { companyCode: '' },
            // 组织者
            openPerDialog: {
                openIndex: 0,
                showDialog: false,
                checkedList: []
            },
            fileOptions: [], // 文件类型数字字典
            // 合同模板选择
            templateFile: {
                name: '',
                advanceLabel: '合同模板',
                advanceConfig: [{ prop: 'templateCode', value: '合同编码' }, { prop: 'templateName', value: '文件名称' }],
                tableConfig: [{ prop: 'templateCode', value: '合同编码' }, { prop: 'templateName', value: '文件名称' }],
                advanceUrl: '/bid/bidHeadQueryTemplate',
                prefix: '/api-srm-web',
                cbParams: ['templateCode', 'templateName', 'fileInfoDtos', 'attachmentId', 'createUserCode']
            },
            iflowId: this.$route.query.mbpmFlowId,
            uploadFileIdx: 0,
            depositFlag: false, // 保证金判断/成功：true，失败：false
            depositRationFlag: false // 押金判断/成功：true，失败：false
        };
    },

    mounted() {
        // 数字字典
        this.APPENDIX_TYPE();
        dictWithUrl('SYS_COLLECT_TYPE,BID_HEAD_FILE_TYPE,BID_YES_NO').then(item => {
            this.dictData = item.data;
        });
    },
    computed: {
        ...mapGetters(['currentTenant', 'applicationCode', 'tenantCode']),
        loginState() {
            return this.$store.state.bidData;
        }
    },
    methods: {
        copyBidFunc() {
            this.showCopyDialog = true;
        },
        upOssFiles(idx) {
            if(!this.saveButton){
                this.uploadTip()
            }else{
                this.uploadFileIdx = idx
                this.dialogVisible = true;
            }
        },
        // 合同模板选择弹框
        async detaliSearchSure(data) {
            // const res = this.formFoot.tableData.find((item) => {
            //     return item.moduleType === '1' && item.fixedTemplate === '1';
            // });
            // if (res) { this.$message.error('合同模板只能选择一个，请先把当前选择的合同模板删除再操作'); return; }
            const params = {
                fileId: data.fileInfoDtos[0].id,
                templateName: data.templateName,
                bidNo: this.$route.query.bidNo,
                attachmentId: data.attachmentId,
                mipAccount: data.createUserCode,
                extStr1: 'Y',
                templateCode: data.templateCode,
                id: this.formFoot.tableData[this.uploadFileIdx].id,
            };
            let url = '';// 判断是否特权修改，是的话加上特定参数
            if (this.isPrivilege) { url = `?specialChange=Y&changeSeq=${this.changeSeq}&changeReson=${this.changeReson}`; }
            this.$set(this.formFoot.tableData[this.uploadFileIdx], 'loading', true)
            await contractSelect(params, url);
            this.$set(this.formFoot.tableData[this.uploadFileIdx], 'loading', false)
            this.flieList();
        },
        detail(current, idx) {
            this.uploadFileIdx = idx
            const advanceCascade = {};
            if (current.advanceCascade && Object.prototype.toString.call(current.advanceCascade) === '[object String]') {
                let advanceArray = [];
                advanceArray = current.advanceCascade.split(',');
                advanceArray.map(item => {
                    let { 0: sourceProp, 1: destProp } = item.split('#');
                    destProp = destProp || sourceProp;
                    advanceCascade[destProp] = this.searchData[sourceProp];
                });
            }
            this.$refs.advanceDialog.show(true, current, advanceCascade);
        },
        async APPENDIX_TYPE() {
            const res = await dictWithUrl('BID_HEAD_FILE_TYPE');
            for (const key in res.data.BID_HEAD_FILE_TYPE) {
                if (key) {
                    const obj = {};
                    obj.value = key;
                    obj.label = res.data.BID_HEAD_FILE_TYPE[key];
                    if (obj.value === '4') {
                        obj.disabled = true;
                    }
                    this.fileOptions.push(obj);
                }
            }
            this.flieList();
        },
        fixedChange(row) { // 附件类型改变时，主合同默认给否
            row.extStr1 = 'N';
            if (row.moduleType === '1') {
                row.extStr1 = '';
            }
        },
        getExtStr1(row, val) { row.extStr1 = val[0]; },
        // 发起招标文件列表
        async flieList() {
            if (!this.$route.query.bidNo) {
                return;
            }
            const fileRes = await uploadListNew({ moduleNo: this.$route.query.bidNo, moduleTypes: ['1', '2', '3', '4', '5', ''], fileAttributes: ['1', '2', '3', '4'] });
            if (fileRes && fileRes.code === '0') {
                this.formFoot.tableData = fileRes.data.list;
                this.conversionData(this.formFoot.tableData);
            }
        },
        addNewRow(){
            this.formFoot.tableData.push({moduleType: '2', fixedTemplateText: '否',fixedTemplate: '2', extStr1: 'N', _extStr1: '否'})
        },
        templateSelect() {
            this.$message.warning('当前状态不能选择');
            return false;
        },

        privilegeClick() { // 特权修改
            this.showPrivilegeDialog = true;
        },
        privilegeConfirm(value) {
            this.changeReson = value;
            this.saveButton = true;
            this.isPrivilege = true;
            this.changeSeq = new Date().getTime() + this.$route.query.bidNo;
        },
        async preserveContract() { // 保存
            this.$confirm('请检查“标书定价(元)”，“投标保证金金额(元)”是否填写正确', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let fileResSave = false;
                this.initCheckFlag();
                this.$refs['footForms'].validate(async (valid) => { // 防止用户没点文件保存直接保存标书
                    if (valid) {
                        if(dayjs(this.form.purchaseStartTime).valueOf() >= dayjs(this.form.quoteStartTime).valueOf() || dayjs(this.form.depositEndTime).valueOf() >= dayjs(this.form.quoteStartTime).valueOf() || dayjs(this.form.signUpEndTime).valueOf() >= dayjs(this.form.quoteStartTime).valueOf()) {
                            fileResSave = true
                            return this.$message.warning('报名截止时间、标书购买开始时间、保证金提交截止时间必须小于报价开始时间')
                        }
                        const isMainContract = this.formFoot.tableData.filter((item) => { return item.extStr1 === 'Y'; });
                        if (isMainContract.length === 0) { this.$message.warning('必须要有一个为主合同'); fileResSave = true; }
                    } else {
                        this.$message.error('请输入完整的招标文件信息！');
                        fileResSave = true;
                    }
                });
                if (fileResSave) { return; }
                this.saveListFn(false);
                // 判断是否同时含有合同文件、标书文件、竞标单位回执
                let contractFile = false;
                let bidFile = false;
                let receiptFile = false;
                let allFile = false;
                this.formFoot.tableData.forEach(item => {
                    if (item.moduleType === '1') {
                        bidFile = true;
                    } else if (item.moduleType === '2') {
                        contractFile = true;
                    } else if (item.moduleType === '4') {
                        receiptFile = true;
                    }
                });
                if (contractFile && bidFile && receiptFile) { // 如果全部文件都有
                    allFile = true;
                }
                this.$refs['contractInfo'].$refs['form'].validate(async valid => {
                    if (valid) {
                        // 检查投标保证金金额、检查合同押金比例
                        this.checkDeposit().then(async bool => {
                            if (bool) {
                                if (this.form.skillProportion * 1 + this.form.businessProportion * 1 + this.form.priceProportion * 1 !== 100) {
                                    this.$message.error('技术权重+商务权重+价格权重不等于100');
                                    return false;
                                } else if (this.form.cashRation * 1 + this.form.oilCardRation * 1 + this.form.acceptanceRation * 1 !== 100) {
                                    let oilText = '现汇比例+油卡比例+承兑比例不等于100';
                                    if (!this.isOilCardRation) { oilText = '现汇比例+承兑比例不等于100'; }
                                    this.$message({
                                        showClose: true,
                                        message: oilText,
                                        type: 'error'
                                    });
                                    return false;
                                } else if (!allFile) {
                                    this.$message.error('必须同时有合同文件、招标文件、竞标单位回执');
                                    return false;
                                } else if (this.form.syntheticalScore === 'Y' && this.form.businessProportion * 1 === 0 && this.form.skillProportion * 1 === 0) {
                                    this.$message.error('请维护技术分权重或商务分权重');
                                    return false;
                                }
                                this.loadSave = true;
                                let params = { ...this.form };
                                if (this.isPrivilege) { params = { ...this.form, changeSeq: this.changeSeq, specialChange: 'Y', changeReson: this.changeReson }; }
                                if (this.form.collectTypeCode && Object.prototype.toString.call(this.form.collectTypeCode).slice(8, -1) === 'Array') {
                                    params.collectTypeCode = this.form.collectTypeCode.join(',');
                                }
                                if (!params.collectTypeCode) {
                                    params.collectTypeName = '';
                                }
                                if (!params.transType) {
                                    params.transType = '';
                                }
                                //20241121版本需求【招议标方案特批】字段删除，入参一律改为N
                                params.specialPermitFlag = 'N'
                                const res = await contractSave(this.$route.query.bidNo, params);
                                this.loadSave = false;
                                if (res && res.code === '0') {
                                    this.$refs['contractInfo'].initState = true;
                                    this.$store.dispatch('getGeneAction', {
                                        bidNo: this.$route.query.bidNo, iflowId: this.iflowId
                                    });
                                    if (this.form.syntheticalScore === 'Y') {
                                        this.$store.commit('isMuTaScoreBtn', true);
                                    } else { this.$store.commit('isMuTaScoreBtn', false); }
                                    this.init();
                                    this.$message.success('操作成功');
                                }
                            }
                        });
                    } else {
                        // 需确认，depositRationFlag 和 this.depositFlag 一直为 false
                        // if (this.depositRationFlag && this.depositFlag) this.$message.error('请输入完整的信息');
                        this.$message.warning('请输入完整的信息');
                    };
                });
            })
        },
        async uploadFile(file) { // 合同模板上传
            if (!this.$route.query.bidNo) {
                this.$message.warning('招标编码为空，上传有误!');
                return false;
            }
            const arr = [];
            file.forEach(item => {
                const obj = {};
                const fileArr = item.localFileName.split('_');
                const type = item.downUrl.split('.').pop();
                obj.moduleNo = this.$route.query.bidNo;
                obj.moduleType = this.formFoot.tableData[this.uploadFileIdx].moduleType;
                obj.fixedTemplate = '2';
                obj.fileId = item.id;
                obj.fileUrl = item.downUrl;
                obj.fileName = item.localFileName;
                obj.fileAttribute = '1';
                obj.fileType = item.downUrl.split('.')[item.downUrl.split('.').length - 1];
                //第四条合同文件主合同肯定为是，其余情况都是否
                obj.extStr1 = this.uploadFileIdx === 3 ? 'Y' : 'N';
                arr.push(obj);
            });
            //招标文件上传需要添加saveSource=bidHead，后端用来区分
            let url = '?saveSource=bidHead';
            // 判断是否特权修改，特权修改的话加上特定参数
            if (this.isPrivilege) { url += `&specialChange=Y&changeSeq=${this.changeSeq}&changeReson=${this.changeReson}`; }
            let res
            this.$set(this.formFoot.tableData[this.uploadFileIdx], 'loading', true)
            if(this.formFoot.tableData[this.uploadFileIdx].id){
                //文件覆盖
                res = await updateModuleFile({...arr[0], saveSource: 'bidHead'}, this.formFoot.tableData[this.uploadFileIdx].id + url);
            }else{
                //新上传
                res = await uploadTemplate(arr, url);
            }
            this.$set(this.formFoot.tableData[this.uploadFileIdx], 'loading', false)
            // updateModuleFile
            if (res && res.code === '0') {
                this.$message.success('文件上传成功');
                this.flieList();
            }
        },
        uploadTip() {
            this.$message.error('当前状态不能上传');
            return false;
        },
        delFileBtn(row, idx) { // 招标文件删除
            this.$confirm('是否确定要删除？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async() => {
                if(row.id){
                    //有文件
                    let url = '';// 判断是否特权修改，特权修改的话加上特定参数
                    if (this.isPrivilege) { url = `?specialChange=Y&changeSeq=${this.changeSeq}&changeReson=${this.changeReson}`; }
                    const res = await delFile(row.id, url);
                    if (res && res.code === '0') {
                        this.flieList();
                        this.$message.success('操作成功');
                    }
                }else{
                    //没文件
                    this.formFoot.tableData.splice(idx, 1)
                }
            }).catch(() => {});
        },
        previewBtn(row) { filePreview(row); }, // 招标文件预览
        downloadBtn(row) { // 招标文件下载
            const url = row.downUrl || row.fileUrl;
            window.open(url, '_parent');
        },
        async init() {
            // 按钮状态判断
            if (this.form.syntheticalScore === 'N') { this.form.priceProportion = 100; }
            if (this.form.bidStatus >= '30' && this.form.bidStatus <= '43') { // 特权修改按钮控制
                this.privilegeBtn = true;
            } else { this.privilegeBtn = false; }
            // 招标状态 是 新建00 或 标书驳回20
            if (this.form.bidStatus === '00' || this.form.bidStatus === '20') {
                this.saveButton = true;
            } else if (this.form.bidStatus === '10') {
                // 招标状态 是 标书待审10
                const mipRes = await mipFlowType({ fdId: this.form.fdIds.split(',')[0] });
                const iFlowType = mipRes.data.list[0].auditStatus;
                if (iFlowType === '00' || iFlowType === '30' || iFlowType === '80') { this.saveButton = true; } else { this.saveButton = false; }
            } else {
                this.saveButton = false;
            }
            // 如果当前登入没有填的的话自动带出当前登入人的信息
            if (!this.form.siteName && !this.form.organizerName) {
                this.form.organizerName = this.$store.state.user.userName;
                this.form.organizerCode = this.$store.state.user.userCode;
                const siteRes = await getCompanySite({ escoCompanyNo: this.$store.state.user.orgCode });
                if (siteRes.data.list[0] && siteRes) {
                    this.form.companyName = siteRes.data.list[0].branchCompanyName;
                    this.form.companyCode = siteRes.data.list[0].branchCompanyNo;
                    this.form.siteName = siteRes.data.list[0].escoCompanyNameCn;
                    this.form.siteCode = siteRes.data.list[0].escoCompanyNo;
                }
            }
        },
        newTempDownload(){
            tplDownload().then(res => {
                if (res && +res.code === 0) {
                    const url = res.data.downUrl;
                    window.open(url, '_parent');
                }
            })
        },
        conversionData(list) {
            const fixedTemplateArr = { '1': '是', '2': '否' };
            list.forEach(item => { 
                item.fixedTemplateText = fixedTemplateArr[item.fixedTemplate];
                item._extStr1 = this.dictData.BID_YES_NO[item.extStr1];
                item._moduleType = this.dictData.BID_HEAD_FILE_TYPE[item.moduleType];
             });
        },
        closePerDialog(data) { this.openPerDialog.showDialog = data.open; },
        async overPerDialog(data) {
            this.openPerDialog.showDialog = data.open;
            if (data.checklist.length !== 0) {
                this.openPerDialog.checkedList = data.checklist;
                this.form.organizerCode = data.checklist[0].userCode;
                this.form.organizerName = data.checklist[0].userName;
            }
        },
        saveList() { // 保存合同列表
            this.$refs['footForms'].validate(async (valid, object) => {
                if (valid) {
                    // const isMainContract = this.formFoot.tableData.filter((item) => { return item.extStr1 === 'Y'; });
                    // if (isMainContract.length === 0) { this.$message.warning('必须要有一个为主合同'); return; }
                    if(this.formFoot.tableData.every(v => v.id)){
                        this.saveListFn();
                    }else{
                        this.$message.warning('请先上传文件！')
                    }
                } else {
                    this.loadDeaSave = false;
                    this.$message.error('请输入完整的信息！');
                }
            });
        },
        async saveListFn(tip = true) {
            const arr = [];
            this.formFoot.tableData.forEach(item => {
                const obj = { id: item.id, moduleType: item.moduleType, version: item.version };
                if (item.extStr1) {
                    obj.extStr1 = item.extStr1;
                } else { obj.extStr1 = 'N'; }
                arr.push(obj);
            });
            //招标文件保存需要添加saveSource=bidHead，后端用来区分
            let url = '?saveSource=bidHead';
            // 判断是否特权修改，特权修改的话加上特定参数
            if (this.isPrivilege) { url += `&specialChange=Y&changeSeq=${this.changeSeq}&changeReson=${this.changeReson}`; }// 判断是否特权修改，是的话加上特定参数
            const res = await uploadPost(url, arr);
            if (res) { if (tip) { this.$message.success('操作成功'); } }
            this.flieList();
        },
        // 初始化后台查询的标识
        initCheckFlag() {
            this.depositFlag = false;
            this.depositRationFlag = false;
        },
        // 校验投标保证金金额和合同押金比例
        async checkDeposit() {
            let flag = false;
            const params = {
                businessScale: this.form.businessScale,
                businessType: this.form.businessType,
                transType: this.form.transType
            };
            /**
             * configType: 1 投标保证金金额  configType: 2 合同押金比例
             * digitalValue: 值，如果是合同押金比例，需要除以100
             * */
            const res1 = await checkDigitalValue({ ...params, configType: 1, digitalValue: this.form.deposit });
            if (res1 && +res1.code === 0) {
                const res2 = await checkDigitalValue({ ...params, configType: 2, digitalValue: (this.form.contractDepositRation / 100) });
                if (res2 && +res2.code === 0) {
                    flag = true;
                }
            }
            return flag;
        }
    },
    watch: {
        loginState: {
            handler(val) {
                this.form = val;
                this.form.extraProportion = 100; // 附加分权重写死100%
                if (this.form.collectTypeCode && Object.prototype.toString.call(this.form.collectTypeCode).slice(8, -1) === 'String') {
                    this.form.collectTypeCode = this.form.collectTypeCode.split(',');
                }
                this.siteFormData.companyCode = val.companyCode;
                if (this.form.currency === null) {
                    this.form.currency = 'CNY';
                }
                if (this.form.rankedVisible === null || this.form.rankedVisible === '') {
                    this.form.rankedVisible = '2';
                }
                if (this.form.priceMax === null) {
                    this.form.priceMax = undefined;
                }
                if (this.form.customers) {
                    this.form.customerCode = this.form.customers.map(item => item.customerCode).join(',');
                    this.form.customerName = this.form.customers.map(item => item.customerName).join(',');
                }
                this.init();
            },
            deep: true
        }
    }
};